export default "__VITE_PUBLIC_ASSET__b3c3ffc2__"